module.exports = __webpack_public_path__ + "img/bars.f4e9e8e1.svg";